import React, { useEffect, useState } from "react";
import axios from "axios";
import { DataGrid, GridOverlay } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Loader from "./Loader";
// import { Button } from '@mui/material';
import { toast } from "react-toastify"; // Import toast from react-toastify
import { Button, Grid, TextField } from "@mui/material";
import "react-toastify/dist/ReactToastify.css";
import { DateRangePicker, Popper } from "rsuite";
import "rsuite/dist/rsuite.css";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import EditIcon from "@mui/icons-material/Edit";
import { IconButton, Tooltip } from "@mui/material";
import { Modal, Form } from "react-bootstrap";
import { Formik } from "formik";
import * as Yup from "yup";

const OverView = () => {
  const [rows, setRows] = useState([]);
  const [ogrows, setOGRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    userNameoremail: "",
    startDate: null,
    endDate: null,
  });
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedDateRange, setSelectedDateRange] = useState([]);

  const [showModal, setShowModal] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const handleEditEmail = (row) => {
    // alert(JSON.stringify(row.user_id_pk));
    setSelectedUser(row);
    setShowModal(true);
  };

  // const validationSchema = Yup.object({
  //     user_email: Yup.string().email("Invalid email format").required("Email is required"),
  // });

  const validationSchema = Yup.object({
    user_email: Yup.string()
      .trim()
      .strict(true)
      .matches(
        /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/,
        "Enter a valid email address (e.g. user@example.com)"
      )
      .required("Email is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      setLoading(true);

      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/updateUserEmail/admin/`,
        {
          security_key: "C3RL@Pl[LsRfmqJ63_",
          data: {
            user: "admin",
            user_id_pk: selectedUser.user_id_pk,
            ...values,
          },
        }
      );

      const success = response?.message?.success;
      const result = response?.message?.message;

      if (success && result === 1) {
        setRows((prevRows) =>
          prevRows.map((row) =>
            row.id === selectedUser.id
              ? { ...row, user_email: values.user_email }
              : row
          )
        );
        setShowModal(false);
        setSelectedUser(null);
      }
    } catch (error) {
      console.error("Error updating data:", error);
    } finally {
      setSubmitting(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    // Replace this URL with your actual API endpoint
    const fetchData = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/getuserList/admin/`,
          {
            security_key: "C3RL@Pl[LsRfmqJ63_",
            data: {
              user: "admin",
            },
          }
        );

        if (response.message.success) {
          const ResponseData = response.message.message;
          const userData = ResponseData.map((item, index) => {
            const createdRaw = item.created_on || ""; // fallback to empty string
            const date = new Date(createdRaw);
            const formattedCreatedOn = isNaN(date.getTime())
              ? ""
              : `${String(date.getMonth() + 1).padStart(2, "0")}/${String(
                  date.getDate()
                ).padStart(2, "0")}/${date.getFullYear()}`;

            return {
              id: index + 1,
              // id: item.user_id_pk,
              user_id_pk: item.user_id_pk,
              user_name: item.user_name || "N/A",
              user_email: item.user_email || "N/A",
              created_on_raw: createdRaw, // keep original ISO or timestamp for filtering
              created_on: formattedCreatedOn,
            };
          });
          setOGRows(userData);
          setRows(userData);
          console.log("userData", userData);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const columns = [
    // { field: 'serialNumber', headerName: 'S. No. ', width: 70 },
    { field: "id", headerName: "S. No.", width: 70, hide: true },
    { field: "user_name", headerName: "User Name", width: 200 },
    // { field: "user_email", headerName: "User Email", width: 300 },
    {
      field: "user_email",
      headerName: "User Email",
      width: 300,
      renderCell: (params) => (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <span>{params.value}</span>
          <Tooltip title="Edit Email">
            <IconButton
              size="small"
              onClick={() => handleEditEmail(params.row)}
            >
              <EditIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
    {
      field: "created_on",
      headerName: "Joined On",
      type: "number",
      width: 200,
    },
  ];

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters((prev) => {
      if (name === "startDate") {
        return { ...prev, [name]: value, endDate: null };
      }
      const updatedFilters = { ...prev, [name]: value };
      if (name === "userNameoremail") {
        applyFilterswithnameemail(updatedFilters); // Trigger filter immediately for name/email change
      }
      return updatedFilters;
    });
  };
  const handleDateRangeChange = (value) => {
    console.log(value);
    if (value == null || value.includes(0, null)) {
      setSelectedDateRange([]);
      setFilters((prev) => {
        const updatedFilters = { ...prev, startDate: null, endDate: null };
        applyFilters(updatedFilters);
        return { ...prev, startDate: null, endDate: null };
      });
    } else {
      setSelectedDateRange([value[0], value[1]]);
      setFilters((prev) => {
        const updatedFilters = {
          ...prev,
          startDate: value[0],
          endDate: value[1],
        };
        applyFilters(updatedFilters);
        return { ...prev, startDate: value[0], endDate: value[1] };
      });
    }
  };

  const applyFilters = (updatedFilters) => {
    const filteredRows = ogrows.filter((row) => {
      // Filter by username or email (both are checked with the same filter input)
      const matchesUserNameOrEmail =
        row.user_name
          .toLowerCase()
          .includes(updatedFilters.userNameoremail.toLowerCase()) ||
        row.user_email
          .toLowerCase()
          .includes(updatedFilters.userNameoremail.toLowerCase()) ||
        updatedFilters.userNameoremail.trim() === "";

      const createdDate = new Date(row.created_on_raw);
      const startDate = updatedFilters.startDate
        ? new Date(updatedFilters.startDate)
        : null;
      const endDate = updatedFilters.endDate
        ? new Date(updatedFilters.endDate)
        : null;

      const normalizeDate = (date) => {
        if (!date) return null;
        date.setHours(0, 0, 0, 0); // Set time to midnight
        return date;
      };

      const normalizedStartDate = normalizeDate(startDate);
      const normalizedEndDate = normalizeDate(endDate);
      const normalizedCreatedDate = normalizeDate(new Date(createdDate));

      // Date filtering logic
      const matchesStartEndDate =
        (!normalizedStartDate ||
          normalizedCreatedDate >= normalizedStartDate) &&
        (!normalizedEndDate || normalizedCreatedDate <= normalizedEndDate);
      return matchesUserNameOrEmail && matchesStartEndDate;
    });

    const updatedRows = filteredRows.map((row, index) => ({
      ...row,
      id: index + 1,
    }));

    setRows(updatedRows);
  };
  const applyFilterswithnameemail = (updatedFilters) => {
    const filteredRows = ogrows.filter((row) => {
      // Filter by username or email (both are checked with the same filter input)
      const matchesUserNameOrEmail =
        row.user_name
          .toLowerCase()
          .includes(updatedFilters.userNameoremail.toLowerCase()) ||
        row.user_email
          .toLowerCase()
          .includes(updatedFilters.userNameoremail.toLowerCase()) ||
        updatedFilters.userNameoremail.trim() === "";

      const createdDate = new Date(row.created_on_raw);
      const startDate = updatedFilters.startDate
        ? new Date(updatedFilters.startDate)
        : null;
      const endDate = updatedFilters.endDate
        ? new Date(updatedFilters.endDate)
        : null;

      const normalizeDate = (date) => {
        if (!date) return null;
        date.setHours(0, 0, 0, 0); // Set time to midnight
        return date;
      };

      const normalizedStartDate = normalizeDate(startDate);
      const normalizedEndDate = normalizeDate(endDate);
      const normalizedCreatedDate = normalizeDate(new Date(createdDate));

      // Date filtering logic
      const matchesStartEndDate =
        (!normalizedStartDate ||
          normalizedCreatedDate >= normalizedStartDate) &&
        (!normalizedEndDate || normalizedCreatedDate <= normalizedEndDate);
      return matchesUserNameOrEmail && matchesStartEndDate;
    });

    const updatedRows = filteredRows.map((row, index) => ({
      ...row,
      id: index + 1,
    }));

    setRows(updatedRows);
  };
  const handleSelectionChange = (newSelection) => {
    setSelectedRows(newSelection.rowIds);
  };

  const exportToCSV = () => {
    // Sort the rows in ascending order by the 'created_on_raw' date
    const sortedRows =
      selectedRows.length > 0
        ? rows.filter((row) => selectedRows.includes(row.id))
        : [...rows];
    console.log(rows);
    sortedRows.sort(
      (a, b) => new Date(a.created_on_raw) - new Date(b.created_on_raw)
    );

    if (sortedRows.length === 0) {
      toast.warning("No data available to export.", {
        position: "top-right",
        autoClose: 3000,
        closeButton: true,
      });
      return;
    }

    // Prepare CSV Header
    const header = ["S. No.", "User Name", "User Email", "Joined On"];
    const csvRows = [header];

    // Prepare CSV Data
    sortedRows.forEach((row, index) => {
      const date = new Date(row.created_on_raw);
      const formattedDate = formatDate(date);
      csvRows.push([index + 1, row.user_name, row.user_email, formattedDate]);
    });

    // Convert array of rows into CSV string
    return csvRows.map((row) => row.join(",")).join("\n");
  };

  const formatDate = (date) => {
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}-${day}-${year}`;
  };

  // Function to trigger the CSV download
  const triggerDownload = () => {
    try {
      const csvData = exportToCSV();
      if (!csvData) {
        throw new Error("No data available for export");
      }

      const blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.href = url;
      link.download = "user_data.csv";
      document.body.appendChild(link); // for Firefox
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);

      // Show success toast
      toast.success("CSV file successfully downloaded", {
        position: "top-right",
        autoClose: 3000,
        closeButton: true,
      });
    } catch (error) {
      // Show error toast
      //   toast.error("CSV export failed: " + error.message, {
      //     position: "top-right",
      //     autoClose: 3000,
      //     closeButton: true,
      // });
    }
  };

  console.log(selectedRows);
  const resetFilters = () => {
    setFilters({ userNameoremail: "", startDate: null, endDate: null });
    setRows(ogrows); // Reset the rows to original data
    setSelectedDateRange([]);
  };
  console.log(filters);
  const StyledGridOverlay = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    "& .no-results-primary": {
      fill: "#3D4751",
      ...theme.applyStyles("light", {
        fill: "#AEB8C2",
      }),
    },
    "& .no-results-secondary": {
      fill: "#1D2126",
      ...theme.applyStyles("light", {
        fill: "#E8EAED",
      }),
    },
  }));

  function CustomNoResultsOverlay() {
    return (
      <StyledGridOverlay>
        <Box sx={{ mt: 2 }}>No data found.</Box>
      </StyledGridOverlay>
    );
  }
  const NoShadowPaper = styled(Paper)({
    boxShadow: "none !important",
  });

  const [isSmallScreen, setIsSmallScreen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth <= 600);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <Card sx={{ boxShadow: "none" }}>
      <style>
        {`
                    p {
                    margin-bottom: 0;
                    }
                   .rs-picker-daterange-header {
                            text-transform: lowercase !important;
                    }
                    .rs-picker-header-date  {
                        text-transform: lowercase !important;
                    }

                   
                        
                    `}
      </style>
      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Edit User Email</Modal.Title>
        </Modal.Header>

        {selectedUser && (
          <Formik
            initialValues={{ user_email: selectedUser.user_email }}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
          >
            {({
              handleSubmit,
              handleChange,
              values,
              touched,
              errors,
              isSubmitting,
              handleBlur,
            }) => (
              <Form noValidate onSubmit={handleSubmit}>
                <Modal.Body>
                  <Form.Group controlId="formUserEmail">
                    <Form.Label>Email address</Form.Label>
                    <Form.Control
                      type="email"
                      name="user_email"
                      placeholder="Enter email"
                      value={values.user_email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      isInvalid={touched.user_email && !!errors.user_email}
                      autoFocus
                    />
                    <Form.Control.Feedback type="invalid">
                      {errors.user_email}
                    </Form.Control.Feedback>
                  </Form.Group>
                </Modal.Body>

                {/* <Modal.Footer>
                                    <Button
                                        variant="secondary"
                                        onClick={() => setShowModal(false)}
                                        disabled={isSubmitting}
                                    >
                                        Cancel
                                    </Button>
                                    <Button variant="primary" type="submit" disabled={isSubmitting}>
                                        Save
                                    </Button>
                                </Modal.Footer> */}
                <Modal.Footer>
                  <Button
                    variant="outlined"
                    style={{
                      backgroundColor: "#fff",
                      borderColor: "#000000",
                      color: "#000000",
                    }}
                    onClick={() => setShowModal(false)}
                    disabled={isSubmitting}
                    className="me-2"
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    style={{ backgroundColor: "#000000" }}
                    type="submit"
                    disabled={isSubmitting}
                  >
                    Save
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        )}
      </Modal>

      <CardContent>
        <Typography variant="h6" gutterBottom>
          Users
        </Typography>

        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={12} md={5}>
            <Typography
              variant="caption"
              display="block"
              gutterBottom
              style={{ fontSize: "14px" }}
            >
              Filter by First Name or Email
            </Typography>
            <TextField
              fullWidth
              size="small"
              // label="Enter name or email"
              name="userNameoremail"
              value={filters.userNameoremail}
              placeholder="Enter name or email"
              onChange={handleFilterChange}
              style={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Typography
              variant="caption"
              display="block"
              gutterBottom
              style={{ fontSize: "14px" }}
            >
              Filter by Date Range
            </Typography>
            <DateRangePicker
              value={selectedDateRange}
              onChange={handleDateRangeChange}
              placeholder="dd/mm/yyyy ~ dd/mm/yyyy"
              // format='DD/MM/YYYY'
              showOneCalendar={isSmallScreen}
              size="lg"
              style={{
                width: "100%",
                maxWidth: "300px",
              }}
              placement="bottomStart"
            />
          </Grid>
          <Grid item xs={6} md={2}>
            <Box
              sx={{ height: "100%", display: "flex", alignItems: "flex-end" }}
            >
              <Button
                fullWidth
                variant="outlined"
                style={{
                  backgroundColor: "#fff",
                  borderColor: "#000000",
                  color: "#000000",
                }}
                onClick={resetFilters}
              >
                Reset
              </Button>
            </Box>
          </Grid>

          <Grid item xs={6} md={2}>
            <Box
              sx={{ height: "100%", display: "flex", alignItems: "flex-end" }}
            >
              <Button
                fullWidth
                variant="contained"
                style={{ backgroundColor: "#000000" }}
                onClick={triggerDownload}
              >
                Export CSV
              </Button>
            </Box>
          </Grid>
        </Grid>

        {loading && <Loader />}
        <Paper
          sx={{
            boxShadow:
              "0px 1px 0px -1px rgba(0, 0, 0, 0.2), 0px 1px 17px 2px rgba(0, 0, 0, 0.14), 0px 1px 3px -11px rgba(0, 0, 0, 0.12)",
            width: "100%",
          }}
        >
          <DataGrid
            slots={{
              noRowsOverlay: CustomNoResultsOverlay,
            }}
            rows={rows}
            columns={columns}
            initialState={{
              pagination: {
                paginationModel: { page: 0, pageSize: 10 },
              },
            }}
            pageSizeOptions={[10, 50, { value: -1, label: "All" }]}
            sx={{
              boxShadow: "none",
              border: 0,
              width: "100%",
              overflowX: "auto",
              "& .MuiTablePagination-root": {
                flexWrap: "wrap", // Makes it responsive
              },
              "& .MuiTablePagination-input": {
                display: "inline-flex !important",
              },
            }}
            disableRowSelectionOnClick
            disableColumnMenu
            onSelectionModelChange={handleSelectionChange}

            // loading={rows.length === 0}
          />
        </Paper>
      </CardContent>
    </Card>
  );
};

export default OverView;
